import { request } from '../request'
import http from "../public";

/**
 * 根据状态获取订单
 * @param condition
 * @returns {AxiosPromise}
 */
export function getOrderByType(condition) {
    return request({
        url: "/agg-portal/ap/order/list",
        method: 'get',
        params: condition
    });
}

/**
 * 获取订单详情
 * @param OrderId
 */
export function getOrderDetail(OrderId) {
    return request({
        url: "/agg-portal/ap/order/detail/" + OrderId,
        method: 'get',
    });
}

/**
 * 确认收货
 * @param orderId
 * @returns {AxiosPromise}
 */
export function confirmGoods(orderId) {
    return request({
        url: "/agg-portal/ap/order/confirmReceiveOrder",
        method: 'post',
        params: { orderId: orderId }
    });
}

/**
 * 取消订单
 * @param orderId
 * @returns {AxiosPromise}
 */
export function cancelOrder(orderId) {
    return request({
        url: "/agg-portal/ap/order/cancelUserOrder",
        method: 'post',
        params: { orderId: orderId }
    });
}

/**
 * 删除订单
 * @param orderId
 * @returns {AxiosPromise}
 */
export function deleteOrder(orderId) {
    return request({
        url: "/agg-portal/ap/order/deleteOrder",
        method: 'post',
        params: { orderId: orderId }
    });
}

/**
 * 个人购物车列表
 * @returns {AxiosPromise}
 */
export function getCartList(type) {
    return request({
        url: "/agg-portal/ap/cart/list?type="+type,
        method: 'get',
    });
}

/**
 * 个人购物车详情
 * @param cartIds
 * @returns {AxiosPromise}
 */
export function getCartDetail(cartIds) {
    return request({
        url: "/agg-portal/ap/cart/list/promotion",
        method: 'get',
    });
}

/**
 * 删除购物车中选中的商品
 * @param ids  array
 * @returns {AxiosPromise}
 */
export function deleteCartBySelected(ids) {
    return request({
        url: "/agg-portal/ap/cart/delete",
        method: 'post',
        params: ids
    });
}

/**
 * 修改购物车商品数量
 * @param params
 */
export function updateCartGoodsNum(params) {
    return request({
        url: "/agg-portal/ap/cart/update/quantity",
        method: 'get',
        params: params
    });
}

/**
 * 购物车点击结算生成订单
 * @param data
 */
export function generateOrderOnCart(data) {
    return request({
        url: "/agg-portal/ap/order/generateConfirmOrder",
        method: 'post',
        data: data
    });
}

/**
 * 提交订单
 * @param data
 */
export function subOrderOnCart(data) {
    return request({
        url: "/agg-portal/ap/order/generateOrder",
        method: 'post',
        data: data
    });
}

/**
 * 立即购买生成订单
 * @param data
 */
export function generateOrderOnBuy(data) {
    return request({
        url: "/agg-portal/ap/order/generateConfirmOrderByGoods",
        method: 'post',
        data: data
    });
}

/**
 * 分页获取生情退货记录
 * @param params
 */
export function getApplyRefundRecordList(params) {
    return request({
        url: "/agg-portal/ap/returnApply/pageList",
        method: 'get',
        params: params
    });
}

/**
 * 退货原因
 * @returns {AxiosPromise}
 */
export function getReturnReason() {
    return request({
        url: "/agg-portal/ap/returnReason/list",
        method: 'get',
    });
}

/**
 * 支付成功回调
 * @param params
 * @returns {AxiosPromise}
 */
export function paySuccessAjax(params) {
    return request({
        url: "/agg-portal/ap/order/paySuccess",
        method: 'post',
        params: params
    });
}

/**
 * 获取支付二维码
 * @param params
 * @returns {AxiosPromise}
 */
export function payQcCode(price,product) {
    return request({
        url: "/agg-portal/ap/payment/QcCode?price="+price+"&product="+product,
        method: 'GET',
    });
}

/**
 * 验证订单信息 需要传状态 和 订单id
 * @param params
 * @returns {AxiosPromise}
 */
export function verifyOrder(data) {
    return request({
        url: "/agg-portal/ap/order/verifyOrder",
        method: 'GET',
        params: data
    });
}

export function inquirePayPwd() {
    return request({
        url: "/agg-portal/ap/sso/inquirePayPwd",
        method: 'POST',
    });
}

/**
 * 支付订单
 *
 * @param data
 * @constructor
 */
export function submitPayment(data) {
    return http.fetchPost("/agg-portal/ap/payment/pay",data)
}

/**
 * 获取二维码
 * @returns {AxiosPromise}
 * @constructor
 */
export function verifyOrder1() {
    return request({
        url: "/agg-portal/ap/payment/QcCode",
        method: 'GET',
    });
}

/**
 * 提交退款订单
 * @param data
 * @returns {*|Promise<unknown>}
 */
export function returnApply(data){
    return http.fetchPost("/agg-portal/ap/returnApply/create",data)
}



/**
 * 获取微信的配置文件
 * @returns {AxiosPromise}
 * @constructor
 */
export function getWxConfig() {
    return request({
        url: "/agg-portal/ap/payment/getWxConfig",
        method: 'post',
    });
}

/**
 * 退款项目
 * @param data
 */
export function refundFile(data) {
    return request({
        url: "/agg-portal/ap/returnApply/refundFile",
        method: 'POST',
        data: data,
        headers:{
            "Content-Type":"multipart/form-data"
        }
    });
}


/**
 * 退款项目
 * @param data
 */
export function getlogistics(params) {
    return request({
        url: "/agg-portal/ap/order/logistics",
        method: 'POST',
        params: params
    });
}

/**
 * 获取订单设置
 */
export function orderSetting(id){
    return request({
        url: "/agg-portal/ap/order/orderSetting/"+id,
        method: 'GET',
    });
}

/**
 *  积分结账
 */
export function integralPay(data){
    return request({
        url: "/agg-portal/ap/order/integralPay",
        method: 'post',
        data:data
    });
}
